export const profilesTypes = {
    LOAD_FRIENDS : 'LOAD_FRIENDS_PROFILES',
    LOAD_FILTER : 'LOAD_FILTER_PROFILES',
    SET_PROFILE_TYPE : 'SET_PROFILE_TYPE_PROFILES',
    SET_FILTER : 'SET_FILTER_PROFILES',
    SET_MESSAGE : 'SET_MESSAGE_PROFILES',
    UPDATE_FRIENDLIST : 'UPDATE_FRIENDLIST_PROFILES',
    SET_DONATE : 'SET_DONATE_PROFILES',
    RESET : 'RESET'
};